import * as NextSkyTheme from "@NextSkyTheme/global";
import { eventModal } from "@NextSkyTheme/modal";

if (!customElements.get("outfit-item")) {
  customElements.define(
    "outfit-item",
    class OutfitItem extends HTMLElement {
      constructor() {
        super();
        this.isAction = this.querySelector("outfit-action");
      }

      connectedCallback() {
        this.muteButton = this.querySelector(".outfit-mute-button");
        if (this.muteButton) {
          this.muteButton.addEventListener(
            "click",
            this.toggleSound.bind(this),
            false
          );
        }
        // Capture phase, so the first tap is handled before the theme's own
        // video-local-play listener, which would start the video muted
        this.addEventListener("click", this.firstPlay.bind(this), true);
        this.isAction.addEventListener(
          "click",
          this.initPopup.bind(this),
          false
        );
        this.isAction.addEventListener(
          "keypress",
          function (event) {
            if (event.key === "Enter") {
              this.initPopup.bind(this)(event);
            }
          }.bind(this),
          false
        );
      }

      // The video element is only created on the first tap. Creating it and
      // unmuting it inside that same tap lets browsers play it with sound.
      createVideo(player) {
        if (!player.querySelector("video") && player.loadContentVideo) {
          player.loadContentVideo(player);
        }
        return player.querySelector("video");
      }

      // A tap on a video that has not played yet starts it with sound. Later
      // taps fall through to the theme's play/pause toggle and keep the
      // viewer's sound choice.
      firstPlay(event) {
        const player = event.target.closest(".outfit-video-item");
        if (!player || !this.contains(player)) return;
        if (event.target.closest(".outfit-mute-button")) return;
        if (player.querySelector("video")) return;
        event.preventDefault();
        event.stopPropagation();
        if (this.createVideo(player)) this.playWithSound(player);
      }

      toggleSound(event) {
        event.preventDefault();
        event.stopPropagation();
        const player = this.querySelector(".outfit-video-item");
        if (!player) return;
        const video = this.createVideo(player);
        if (!video) return;
        if (video.muted) {
          this.playWithSound(player);
        } else {
          this.setSound(false);
        }
      }

      playWithSound(player) {
        const video = player.querySelector("video");
        this.closest(".swiper-wrapper")
          ?.querySelectorAll("outfit-item")
          .forEach((item) => item !== this && item.setSound?.(false));
        this.setSound(true);
        if (video.paused) {
          video.play()?.catch(() => {
            // The browser refused sound; play muted rather than not at all
            this.setSound(false);
            video.play()?.catch(() => {});
          });
        }
        player.querySelector(".play-button")?.classList.add("active");
      }

      setSound(on) {
        const video = this.querySelector(".outfit-video-item video");
        if (video) video.muted = !on;
        if (this.muteButton) {
          this.muteButton.classList.toggle("active", on);
          this.muteButton.setAttribute("aria-pressed", on ? "true" : "false");
        }
      }

      initPopup() {
        const template = this.querySelector("template.outfit-popup");
        if (template) {
          const content = document.createElement("div");
          content.appendChild(
            template.content.firstElementChild.cloneNode(true)
          );
          NextSkyTheme.getBody().appendChild(
            content.querySelector("outfit-popup")
          );
          setTimeout(
            () =>
              eventModal(document.querySelector("outfit-popup"), "open", true),
            100
          );
        }
        NextSkyTheme.global.rootToFocus = this.isAction;
      }
    }
  );
}
